import React from 'react';
import { formatDateOnly } from '../utils/dates';

import { useEscapeToClose } from '../hooks/useEscapeToClose';
const PersonalHistoryView = ({ isOpen, onClose, data }) => {
  useEscapeToClose(onClose);   // Escape dismisses this modal
  if (!isOpen) return null;

  // Handle empty or null data
  const safeData = data || {};
  const selectedConditions = safeData.selected_conditions || {};
  const diagnosisDates = safeData.diagnosis_dates || {};
  const dateOfBirth = safeData.date_of_birth;

  // Get conditions by category
  const getConditionsByCategory = () => {
    const conditionsByCategory = {};
    
    Object.entries(selectedConditions).forEach(([condition, isSelected]) => {
      if (isSelected) {
        const category = 'Medical Conditions';
        if (!conditionsByCategory[category]) {
          conditionsByCategory[category] = [];
        }
        conditionsByCategory[category].push({
          name: condition,
          diagnosisDate: diagnosisDates[condition]
        });
      }
    });
    
    return conditionsByCategory;
  };

  const conditionsByCategory = getConditionsByCategory();
  const hasConditions = Object.keys(conditionsByCategory).length > 0;

  return (
    <div className="modal-overlay">
      <div className="modal-content personal-history-modal">
        <div className="modal-header">
          <h2>Personal Medical History - View Only</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          {/* Date of Birth */}
          {dateOfBirth && (
            <div className="date-of-birth-section">
              <strong>Date of Birth:</strong> {new Date(dateOfBirth).toLocaleDateString()}
            </div>
          )}

          {/* Medical Conditions */}
          {hasConditions ? (
            <div className="conditions-summary">
              <h3 className="pshv-conditionsTitle">Selected Medical Conditions:</h3>
              {Object.entries(conditionsByCategory).map(([category, conditions]) => (
                <div key={category} className="pshv-conditionCategory">
                  <h4 className="pshv-categoryName">
                    {category}
                  </h4>
                  <div className="pshv-conditionsList">
                    {conditions.map((condition, index) => (
                      <div key={index} className="pshv-conditionItem">
                        <div className="pshv-conditionName">
                          {condition.name}
                        </div>
                        {condition.diagnosisDate && (
                          <div className="pshv-diagnosisDate">
                            Diagnosis Date: {formatDateOnly(condition.diagnosisDate)}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="pshv-emptyState">
              <p>No medical conditions have been selected.</p>
            </div>
          )}

          {/* Empty state */}
          {!dateOfBirth && !hasConditions && (
            <div className="pshv-noHistoryState">
              <p>No personal medical history has been recorded yet.</p>
              <p className="pshv-emptyStateHint">
                Click "Edit Personal History" to add your medical information.
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PersonalHistoryView;